<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'

const { user, clear } = useUserSession()
const colorMode = useColorMode()

async function logout() {
  await clear()
  await navigateTo('/')
}

const items = computed<DropdownMenuItem[][]>(() => {
  const groups: DropdownMenuItem[][] = [
    [{
      type: 'label',
      label: user.value?.name || user.value?.username || 'Account',
      avatar: {
        src: user.value?.avatar,
        alt: user.value?.username
      }
    }]
  ]

  const accountItems: DropdownMenuItem[] = [{
    label: '与 Nuxi 聊天',
    icon: 'i-lucide-message-circle',
    to: '/dashboard/chat'
  }]
  if (user.value?.role === 'admin') {
    accountItems.push({
      label: '分析',
      icon: 'i-lucide-chart-bar',
      to: '/admin/analytics'
    })
  }
  groups.push(accountItems)

  groups.push([{
    label: '外观',
    icon: 'i-lucide-sun-moon',
    children: [[
      {
        label: '光明',
        icon: 'i-lucide-sun',
        onSelect: () => { colorMode.preference = 'light' },
        checked: colorMode.value === 'light'
      },
      {
        label: '黑暗',
        icon: 'i-lucide-moon',
        onSelect: () => { colorMode.preference = 'dark' },
        checked: colorMode.value === 'dark'
      }
    ]]
  }])

  groups.push([{
    label: '退出登录',
    icon: 'i-lucide-log-out',
    onSelect: logout
  }])

  return groups
})
</script>

<template>
  <UDropdownMenu
    v-if="user"
    :items="items"
    :content="{ align: 'end' }"
  >
    <UButton
      :avatar="{ src: user.avatar, alt: user.username }"
      color="neutral"
      variant="ghost"
      square
      :aria-label="user.username"
    />
  </UDropdownMenu>
</template>
